export default {"src":"/_next/static/media/dark_theme.1dc3aad3.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};